import { useContext } from "react";

import { UserRolesContext } from "./UserRolesContext";

export const useUserRolesContext = () => {
  return useContext(UserRolesContext);
};

export const usePlatformRole = () => {
  const { platformRole } = useUserRolesContext();
  return platformRole;
};
